import { Suspense, lazy } from '@wordpress/element'

const Slider = lazy(() => import("./slider"));

export default {
	Slider: (props: { children: any }) => {
		return (
			<Suspense fallback={ <span></span> }>
				<Slider>{ props.children }</Slider>
			</Suspense>
		)
	}
}
